import * as s from './styles/videoPlayButton.module.css';

import type { IVideoPlayButton } from './types';

const VideoPlayButton = ({
  videoDuration = '',
}: IVideoPlayButton) => (
  <div className={s.playButtonContainer}>
    <div className={s.playButtonCanvas}>
      <div className={s.playButton}>
        <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 7.13398C13.1667 7.51888 13.1667 8.48113 12.5 8.86603L2 14.9282C1.33333 15.3131 0.499999 14.832 0.499999 14.0622L0.5 1.93782C0.5 1.16802 1.33333 0.686896 2 1.0718L12.5 7.13398Z" fill="white"/>
        </svg>
      </div>
      <span className={s.playButtonTimer}>{videoDuration}</span>
    </div>
  </div>
);

export default VideoPlayButton;
